import { render, staticRenderFns } from "./FeedSuperPay.vue?vue&type=template&id=d0c024a2&scoped=true&"
import script from "./FeedSuperPay.vue?vue&type=script&lang=ts&"
export * from "./FeedSuperPay.vue?vue&type=script&lang=ts&"
import style0 from "./FeedSuperPay.scss?vue&type=style&index=0&id=d0c024a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c024a2",
  null
  
)

export default component.exports